import { type ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getToken, setToken } from '../api/client.js';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const [showTokenInput, setShowTokenInput] = useState(!getToken());
  const [tokenValue, setTokenValue] = useState('');

  function handleTokenSave() {
    if (tokenValue.trim()) {
      setToken(tokenValue.trim());
      setShowTokenInput(false);
      window.location.reload();
    }
  }

  if (showTokenInput) {
    return (
      <div className="token-gate">
        <div className="token-gate__card">
          <h1>Seedbutler Label Designer</h1>
          <p>Enter your admin token to continue.</p>
          <input
            type="password"
            placeholder="Bearer token"
            value={tokenValue}
            onChange={(e) => setTokenValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleTokenSave()}
            autoFocus
          />
          <button onClick={handleTokenSave}>Connect</button>
        </div>
      </div>
    );
  }

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="app">
      <nav className="nav">
        <div className="nav__brand">
          <Link to="/">Seedbutler Label Designer</Link>
        </div>
        <div className="nav__links">
          <Link to="/" className={isActive('/') ? 'nav__link--active' : ''}>
            Templates
          </Link>
          <Link to="/templates/new" className={isActive('/templates/new') ? 'nav__link--active' : ''}>
            + New Template
          </Link>
        </div>
        <span className="nav__version">v{__APP_VERSION__}</span>
        <button
          className="nav__token-btn"
          title="Change API token"
          onClick={() => setShowTokenInput(true)}
        >
          ⚙
        </button>
      </nav>
      <main className="main">{children}</main>
    </div>
  );
}
